import React from 'react';

export function SplashScreen() {
    return (
        <div className="splash-screen">
            <div className="splash-content">
                <div className="splash-logo">
                    <span className="icon">📦</span>
                    <h1>BayWhiz</h1>
                </div>
                <div className="splash-spinner">
                    <div className="spinner-ring"></div>
                </div>
                <p className="splash-text">Loading your workspace...</p>
            </div>

            <style>{`
                .splash-screen {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 100vh;
                    width: 100vw;
                    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                    color: #2c3e50;
                    position: fixed;
                    top: 0;
                    left: 0;
                    z-index: 9999;
                }

                .splash-content {
                    text-align: center;
                    animation: fadeIn 0.5s ease-out;
                }

                .splash-logo {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 1rem;
                    margin-bottom: 2rem;
                    font-size: 2.5rem;
                    font-weight: 800;
                    color: #2c3e50;
                }

                .splash-logo .icon {
                    font-size: 3rem;
                    animation: bounce 2s infinite;
                }

                .splash-spinner {
                    margin: 0 auto 1.5rem;
                    width: 50px;
                    height: 50px;
                }

                .spinner-ring {
                    width: 100%;
                    height: 100%;
                    border: 4px solid rgba(52, 152, 219, 0.2);
                    border-top: 4px solid #3498db;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                }

                .splash-text {
                    color: #7f8c8d;
                    font-size: 1rem;
                    letter-spacing: 0.5px;
                    animation: pulse 2s infinite;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                @keyframes bounce {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }

                @keyframes pulse {
                    0%, 100% { opacity: 0.6; }
                    50% { opacity: 1; }
                }

                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
}
